import { Injectable, inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../environments/environment';
import { SENTRY_TOKEN, WINDOW_TOKEN } from '../tokens/app-tokens';
import { AuthRealmService } from './auth-realm.service';
import { RouteCheckerService } from './route-checker.service';

@Injectable({ providedIn: 'root' })
export class LogoutService {
  private keycloakService = inject(KeycloakService);
  private routeCheckerService = inject(RouteCheckerService);
  private window = inject(WINDOW_TOKEN);
  private sentry = inject(SENTRY_TOKEN);

  private readonly realm = AuthRealmService.getRealm();
  private readonly origin = this.window.location.origin;
  private readonly wnPostLogoutUrl = `${this.origin}${this.routeCheckerService.WN_LOGOUT_REDIRECTOR}`;

  public logout(): void {
    this.sentry.setUser(null);

    if (this.realm === environment.APP_WACKER_NEUSON_REALM) {
      this.wnLogout();
      return;
    }
    this.defaultLogout();
  }

  private wnLogout(): void {
    this.keycloakService.logout(this.wnPostLogoutUrl).then(() => this.keycloakService.clearToken());
  }

  private defaultLogout(): void {
    this.keycloakService.logout(this.origin).then(() => {
      this.keycloakService.clearToken();
    });
  }
}
